import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
const learnings = ['Cómo empezar desde cero', 'Cómo crear tu ebook usando inteligencia artificial', 'Cómo crear y configurar tu tienda paso a paso', 'Cómo subir y publicar tu producto correctamente', 'Cómo crear videos publicitarios que vendan', 'Estrategias básicas para conseguir tus primeras ventas'];
export function LearnSection() {
  return <section className="py-20 px-4 bg-darkCard" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="font-display text-3xl md:text-4xl font-bold text-center mb-16 text-white" data-id="element-75">
          ¿Qué vas a aprender en la charla?
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 mb-16" data-id="element-76">
          {learnings.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-white/5 transition-colors duration-300 border border-transparent hover:border-white/10" data-id="element-77">
              <CheckCircle2 className="w-6 h-6 text-whatsapp shrink-0 mt-0.5" data-id="element-78" />
              <p className="text-lg text-gray-200 font-medium" data-id="element-79">{item}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-80">
          <WhatsAppButton data-id="element-81">QUIERO APRENDER ESTO GRATIS</WhatsAppButton>
        </motion.div>
      </div>
    </section>;
}